import React, { Component } from "react";
import { Route, Switch } from "react-router";
import { connect } from "react-redux";

import OrderList from "./OrderList";

class Sales extends Component {
  componentDidMount() {}

  render() {
    return (
      <Switch>
        <Route exact path="/ventes/par-commandes" component={OrderList} />
      </Switch>
    );
  }
}

/********* Container part */

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Sales);



// WEBPACK FOOTER //
// ./src/sales/Sales.js